import React from 'react';
import '../styles/ProgressBar.css'; // Usiamo gli stili definiti per la barra di progresso

/**
 * Componente per visualizzare l'indicatore del progresso corrente in un gioco
 * 
 * @param {Object} props - Proprietà del componente
 * @param {number} props.current - L'elemento corrente
 * @param {number} props.total - Il numero totale di elementi
 * @param {string} [props.className] - Classi CSS aggiuntive per personalizzare lo stile
 * @returns {JSX.Element} Componente indicatore progresso
 */
const ProgressCounter = ({ current, total, className = '' }) => {
  return (
    <div className={`quiz-indicator ${className}`}>
      {current} / {total}
    </div>
  );
};

export default ProgressCounter; 